import { SubAbilityPage } from './SubAbilityPage';
export default SubAbilityPage;
